export const baseUrl = "/cmphelpsupport";
export const URLs = {
    itemDetails: baseUrl + "/details/:subItemIds",
    whatsNew: baseUrl + "/whatsNew"
};


// WEBPACK FOOTER //
// ./src/constants/urls.ts